import { render, staticRenderFns } from "./HorizontalDonutChartWidget.vue?vue&type=template&id=388eb2ba&scoped=true"
import script from "./HorizontalDonutChartWidget.vue?vue&type=script&lang=js"
export * from "./HorizontalDonutChartWidget.vue?vue&type=script&lang=js"
import style0 from "./HorizontalDonutChartWidget.vue?vue&type=style&index=0&id=388eb2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388eb2ba",
  null
  
)

export default component.exports